/* eslint-disable */
import $ from 'jquery'
import { Utils, baseUrl } from './config'

$(".close-icon").on("click", () => {
  $(".jf-ad").slideUp("slow");
});

$(function () {
  var message;
  // 检查是否显示消息通知
  var checkShowNotify = function (message) {
    if (localStorage.getItem('CSOS-DEOPSALERT__KEY')) {
      let obj = JSON.parse(localStorage.getItem('CSOS-DEOPSALERT__KEY'))
      if (obj.text === message.text && obj.id === message.id) {
        $('.devops-alert').hide()
      } else {
        $('.devops-alert .devops-alert-text').html(message.text)
        $('.devops-alert').show()
      }
    } else {
      $('.devops-alert .devops-alert-text').html(message.text)
      $('.devops-alert').show()
    }
  };
  $(".index-service").click(function() {
    return $('html,body').animate({
      scrollTop: $('#service').offset().top
    }, 500);
  });
  // 取消关闭通知
  $("button.close").click(function() {
    $('.devops-alert').hide()
    var obj = {
      text: message.text,
      id: message.id
    }
    localStorage.setItem('CSOS-DEOPSALERT__KEY', JSON.stringify(obj))
  })
  // 获取csos通知维护接口
  $.ajax({
    url: `${baseUrl.homeApiUrl}/v2/utils/notification_banner/csos`,
    type: 'GET',
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    xhrFields: {
      withCredentials: true
    }
  }).done(function(d) {
    console.log('d', d)
    if (d.data) {
      message = d.data
      checkShowNotify(message)
    }
  });
  $.ajax({
    url: `${baseUrl.apiUrl}/current_account`,
    type: 'GET',
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    xhrFields: {
      withCredentials: true
    }
  }).done(function (d) {
    if (d.is_admin) {
      console.log('index.entry--current-account')
      $('header .loginBth .isLogin').show();
      $('.apply-new-header .apply-new-top .isApplyLogin').show();
      $('.freeuse').hide();
      $('.freeuseBtn').hide();
      $('body').show()
    } else {
      $('body').show()
      $('header .loginBth .isntLogin').show();
      $('.apply-new-header .apply-new-top .isntApplyLogin').show();
      $('.freeuse').show();
      $('.freeuseBtn').show();
    }
  }).fail(function(d) {}).always(function(d) {});
  $(window).scroll(function() {
    if ($(this).scrollTop() > 760) {
      $('.fixed-top').css('display', 'block');
    } else {
      $('.fixed-top').css('display', 'none');
    }
  });
  $('.fixed-top').click(function() {
    $('html,body').animate({
      scrollTop: 0
    }, 500);
  });
  var isInWang = false;
  var isMoveverWang = false;
  var id = null;
  $('.wang-box').mouseover(function() {
    isMoveverWang = true;
    return $('.fixed-wang-list').css('display', 'block');
  });
  $('.wang-box').mouseout(function() {
    isMoveverWang = false;
    return id = setTimeout((function() {
      if (!isInWang && !isMoveverWang) {
        return $('.fixed-wang-list').css('display', 'none');
      }
    }), 800);
  });
  $('.fixed-wang-list').mouseover(function() {
    isInWang = true;
    return $('.fixed-wang-list').css('display', 'block');
  });
  $('.fixed-wang-list').mouseout(function() {
    isInWang = false;
    return $('.fixed-wang-list').css('display', 'none');
  });
  // 注释不用locastorage控制，采用接口直接控制
  // var showDeopsAlert = localStorage.getItem('CSOS-DEOPSALERT__KEY')
  // if (!showDeopsAlert || showDeopsAlert != 1) {
  //    $('.devops-alert').show()
  // }

});



// WEBPACK FOOTER //
// ./src/index.entry.js